// Social configuration for Double Rainbow Suites.
export const HANDLE = "doublerainbowsuites";
export const INSTAGRAM_URL = "https://instagram.com/doublerainbowsuites";
export const YOUTUBE_URL = "https://youtube.com/@doublerainbowsuites";

// LIVE INSTAGRAM FEED — official Instagram profile embed (auto-updates).
export const INSTAGRAM_PROFILE_PERMALINK = "https://www.instagram.com/doublerainbowsuites/";
export const INSTAGRAM_EMBED_ENABLED = true;
export const INSTAGRAM_EMBED_URL = "";
